
function SuccessPage() {
  return (
    <section className="confirmation-card">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/c07b0095e6f94aa8afadec3af4d3c063/73db3f811d2f9c9aece2a64dd89c053e5d327dc9?placeholderIfAbsent=true"
        alt="Request confirmation illustration"
        className="confirmation-image"
      />
      <h2 className="confirmation-message">
        We will review your request and notify you with any update
      </h2>
      <button
        className="action-button"
        onClick={() => console.log("View request clicked")}
        aria-label="View your request details"
      >
        View your request
      </button>

      <style jsx>{`
        .confirmation-card {
        positin:absolute;
        top:0;
        left:0;
          display: flex;
          width: 100%;
          height:"100vh"
          flex-direction: column;
          align-items: center;
          font-family:
            Mulish,
            -apple-system,
            Roboto,
            Helvetica,
            sans-serif;
          font-weight: 600;
          justify-content: center;
        }

        .confirmation-image {
          aspect-ratio: 0.99;
          object-fit: contain;
          object-position: center;
          width: 100%;
        }

        .confirmation-message {
          color: #20130d;
          text-align: center;
          font-size: 20px;
          margin-top: 26px;
          font-weight: 600;
        }

        .action-button {
          align-self: stretch;
          border-radius: 12px;
          background-color: #c47d60;
          margin-top: 26px;
          width: 100%;
          padding: 12px 16px;
          gap: 8px;
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          border: none;
          font-family: inherit;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .action-button:hover {
          background-color: #b36e51;
        }

        .action-button:focus {
          outline: 2px solid #20130d;
          outline-offset: 2px;
        }
      `}</style>
    </section>
  );
}

export default SuccessPage;
